import { useContext, useEffect } from 'react';
import { UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom';

type Transition = {
  location: {
    pathname: string;
  };
  retry: () => void;
};

type BlockableNavigator = {
  block: (blocker: (transition: Transition) => void) => () => void;
};

const useNavigationBlocker = (blocker: (transition: Transition) => void, when = true): void => {
  const { navigator } = useContext(NavigationContext);

  useEffect(() => {
    const blockableNavigator = navigator as unknown as Partial<BlockableNavigator>;

    if (!when || typeof blockableNavigator.block !== 'function') {
      return;
    }

    const unblock = blockableNavigator.block((transition: Transition) => {
      const autoUnblockingTransition: Transition = {
        ...transition,
        retry() {
          unblock();
          transition.retry();
        }
      };

      blocker(autoUnblockingTransition);
    });

    return unblock;
  }, [blocker, navigator, when]);
};

export default useNavigationBlocker;
